import React from 'react'
import { Box, Button, Chip, Grid, Typography } from '@mui/material'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import EditIcon from '@mui/icons-material/Edit'
import LockResetIcon from '@mui/icons-material/LockReset'

export const UsuarioCard = ({ info, onEdit, onChangePassword }) => {
    const nombre = info.nombreUsuario || `${info.nombre || ''} ${info.apellidos || ''}`.trim() || info.usuario
    const usuario = info.usuario || info.mail || 'Sin usuario'
    const rol = info.desRol || info.nombre_rol || 'Sin rol'
    const activo = info.activo ?? true
    const almacenes = info.almacenes || []
    const tiposMaquina = info.tiposMaquina || info.tiposMaquinas || []
    const accesoGlobalAlmacenes = info.accesoGlobalAlmacenes ?? false
    const avatarColor = info.color || (activo ? '#fea00a' : '#94a3b8')

    return (
        <Grid
            container
            direction="column"
            size={{ xs: 12 }}
            sx={{
                justifyContent: "start",
                alignItems: "start",
                p: 2,
                gap: 2,
            }}
            className='card-main'
        >
            <Grid
                container
                direction="row"
                size={{ xs: 12 }}
                sx={{
                    justifyContent: "space-between",
                    alignItems: "start",
                    gap: 1,
                }}
            >
                <Grid
                    container
                    direction="row"
                    sx={{
                        justifyContent: "start",
                        alignItems: "center",
                        flex: 1,
                        minWidth: 0,
                    }}
                >
                    <AccountCircleIcon sx={{ fontSize: 42, mr: 1, color: avatarColor }} />
                    <Box sx={{ minWidth: 0 }}>
                        <Typography variant='h6' sx={{ lineHeight: 1.15 }}>
                            {nombre}
                        </Typography>

                        <Typography variant='body2' sx={{ color: 'text.secondary', wordBreak: 'break-word' }}>
                            {usuario}
                        </Typography>
                    </Box>
                </Grid>

                <Chip
                    size="small"
                    label={activo ? 'Activo' : 'Inactivo'}
                    color={activo ? 'success' : 'default'}
                    variant={activo ? 'filled' : 'outlined'}
                />
            </Grid>

            <Grid
                container
                direction="column"
                size={{ xs: 12 }}
                sx={{
                    justifyContent: "start",
                    alignItems: "start",
                    gap: 0.75,
                }}
            >
                <Typography variant='subtitle1' sx={{ fontWeight: 700 }}>
                    {rol}
                </Typography>

                <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}>
                    {accesoGlobalAlmacenes
                        ? 'Acceso global a almacenes'
                        : almacenes.length
                            ? `${almacenes.length} almacen${almacenes.length === 1 ? '' : 'es'} asignado${almacenes.length === 1 ? '' : 's'}`
                            : 'Sin almacenes asignados'}
                </Typography>

                {!accesoGlobalAlmacenes && almacenes.length > 0 && (
                    <Grid container direction="row" sx={{ gap: 0.75 }}>
                        {almacenes.map((almacen) => (
                            <Chip key={almacen} size="small" label={`Almacen ${almacen}`} variant="outlined" />
                        ))}
                    </Grid>
                )}

                <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}>
                    {tiposMaquina.length
                        ? `${tiposMaquina.length} tipo${tiposMaquina.length === 1 ? '' : 's'} de maquina asignado${tiposMaquina.length === 1 ? '' : 's'}`
                        : 'Acceso a todas las maquinas'}
                </Typography>

                {tiposMaquina.length > 0 && (
                    <Grid container direction="row" sx={{ gap: 0.75 }}>
                        {tiposMaquina.map((tipoMaquina) => {
                            const codigoTipoMaquina = typeof tipoMaquina === 'object'
                                ? tipoMaquina.codTipoMaquina ?? tipoMaquina.tipoMaquina ?? tipoMaquina.idTipoMaquina ?? tipoMaquina.id
                                : tipoMaquina
                            const descripcionTipoMaquina = typeof tipoMaquina === 'object'
                                ? tipoMaquina.desTipoMaquina ?? tipoMaquina.desTipo ?? tipoMaquina.descripcion
                                : null

                            return (
                                <Chip
                                    key={codigoTipoMaquina}
                                    size="small"
                                    label={descripcionTipoMaquina ? `${codigoTipoMaquina} - ${descripcionTipoMaquina}` : `Tipo ${codigoTipoMaquina}`}
                                    variant="outlined"
                                />
                            )
                        })}
                    </Grid>
                )}
            </Grid>

            <Grid
                container
                direction="row"
                size={{ xs: 12 }}
                sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 1,
                }}
            >
                <Button variant="text" color="primary" onClick={() => onEdit(info)}>
                    <EditIcon />&nbsp;Editar
                </Button>

                <Button variant="text" color="negro" onClick={() => onChangePassword(info)}>
                    <LockResetIcon />&nbsp;Contraseña
                </Button>
            </Grid>
        </Grid>
    )
}
